import { useWaitingStateStore } from '../../../../store';
import { observer } from 'mobx-react';
import { TaskStepperView } from './TaskStepperView';

export const TaskStepper = observer(
  ({ currentAction }: { currentAction: JSX.Element }) => {
    const store = useWaitingStateStore();
    return (
      <TaskStepperView
        currentAction={currentAction}
        currentStepKey={store.currentStepKey}
        myCohortStartDate={store.myCohortStartDate}
        myCohortOnboardingEndDate={store.myCohortOnboardingEndDate}
        myCohortType={store.myCohortType}
        studyGroup={store.bdmState?.studyGroup ?? null}
        bdm1SurveyFilledOut={store.bdm1SurveyFilledOut}
        bdm1Outcome={store.bdmState?.bdm1Outcome ?? null}
        bdm1SampleDeadline={store.bdm1SampleDeadline}
        retrievalMode={store.bdm1RetrievalMode}
        bdm2SurveyDue={store.isBdm2SurveyDue}
        bdm2SurveyFilledOut={store.bdm2SurveyFilledOut}
        bdm2Outcome={store.bdm2Outcome}
        bdm2SampleDeadline={store.bdm2SampleDeadline}
      />
    );
  },
);
